import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();
  const projectCardStyle = {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '25px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07)',
    border: '1px solid #e5e7eb',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    cursor: 'pointer'
  };

  return (
    <div 
      style={projectCardStyle}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-5px)';
        e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.15)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.07)';
      }}
      onClick={() => navigate(`/project/${project.slug}`)}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}>
        <div style={{ fontSize: '40px', marginRight: '15px' }}>{project.image}</div>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
            <h3 style={{ margin: 0, color: '#1f2937', fontSize: '18px', fontWeight: '600' }}>
              {project.title}
            </h3>
            {project.featured && (
              <span style={{ 
                backgroundColor: '#fbbf24', 
                color: '#92400e', 
                padding: '2px 8px', 
                borderRadius: '12px', 
                fontSize: '11px',
                fontWeight: 'bold'
              }}>
                FEATURED
              </span>
            )}
          </div>
          <div style={{ display: 'flex', gap: '15px', fontSize: '13px', color: '#6b7280', marginBottom: '12px' }}>
            <span>📅 {project.date}</span>
            <span>🏷️ {project.category}</span>
            <span style={{ 
              color: project.status === 'Completed' ? '#059669' : '#d97706',
              fontWeight: '500'
            }}>
              ● {project.status}
            </span>
          </div>
        </div>
      </div>
      
      <p style={{ 
        color: '#4b5563', 
        lineHeight: '1.6', 
        marginBottom: '15px',
        fontSize: '14px'
      }}>
        {project.description}
      </p>
      
      <div style={{ marginBottom: '15px' }}>
        {project.technologies.slice(0, 3).map((tech, index) => (
          <span key={index} style={{
            backgroundColor: '#dbeafe',
            color: '#1e40af',
            padding: '3px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            marginRight: '6px',
            marginBottom: '6px',
            display: 'inline-block'
          }}>
            {tech}
          </span>
        ))}
        {project.technologies.length > 3 && (
          <span style={{ fontSize: '11px', color: '#6b7280' }}>
            +{project.technologies.length - 3} more
          </span>
        )}
      </div>
      
      <button style={{
        backgroundColor: '#2563eb',
        color: 'white',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '6px',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer',
        width: '100%'
      }}>
        View Details
      </button>
    </div>
  );
};

export default ProjectCard;
